/// <amd-module name="Feed/Legacy/Actions/FeedSettings/ChangeDefaultViewHandler" />
import { Feed, FeedView } from "Feed/Common/Contracts/Feed";
import { IFeedSettingsState } from "Feed/Legacy/Components/Settings/IFeedSettingsState";
import { IFeedDataService } from "Feed/Legacy/DataServices/FeedsDataService";

/**
 * User clicked Mark default view button in View's pivot command bar
 */
export class ChangeDefaultViewHandler {
    public static async handleAsync(state: IFeedSettingsState, selectedView: FeedView): Promise<void> {
        if (selectedView == null || selectedView.id == null) {
            // shouldn't run into this error
            throw new Error("selectedView or selectedView.id cannot be null");
        }

        const viewExists = state.views.some((view: FeedView) => {
            return selectedView.id === view.id;
        });

        if (viewExists === false) {
            throw new Error("selectedView doesn't exists");
        }

        const currentFeed = state.feed();
        const feedToUpdate = {
            id: currentFeed.id,
            defaultViewId: selectedView.id,
            project: currentFeed.project
        } as Feed;

        const feedDataService = state.pageContext.getService<IFeedDataService>("IFeedDataService");

        const feed = await feedDataService.updateFeedAsync(feedToUpdate);
        state.feed().defaultViewId = feed.defaultViewId;
    }
}
